import React, { Component } from "react";
import classnames from "classnames";
import { withRouter, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { inject, observer } from "mobx-react";
import menus from "./menus";
import { IconFa } from "components";
import URL_CONFIG from '../../core/services/config'
import "./style.scss";
import { ENABLE_DOCUMENT_DOWNLOAD } from "../../core/utils/constants";

@inject("commonStore")
@observer
class MainSidebar extends Component {
  constructor(props) {
    super(props);
    // LocalStorageから開いているメニューの状態を読み込み
    this.state = {
      openMenus: JSON.parse(localStorage.getItem('sidebarOpenMenus') || '[]')
    };
  }

  componentDidMount = async () => {
    const { history, location, commonStore: {
      hasPermission, settingStore: { getSetting, setting }
    }, dummy } = this.props;

    const flat_menus = menus.map(e => { return e.subtree ? e.subtree : [e] }).flat();
    if (flat_menus.filter(e => e.path === location.pathname)[0] && !hasPermission(flat_menus.filter(e => e.path === location.pathname)[0]?.permission)) {
      history.push("/");
    }

    if (!dummy && (!setting || Object.keys(setting).length === 0)) {
      await getSetting();
    }

  }
  onClickMenu = (local, path) => {
    this.setState({
      active: local
    });
  };

  // treeviewの開閉を制御するハンドラー
  handleTreeviewToggle = (key) => {
    this.setState(prevState => {
      const openMenus = [...prevState.openMenus];
      const index = openMenus.indexOf(key);

      if (index > -1) {
        // 既に開いている場合は閉じる
        openMenus.splice(index, 1);
      } else {
        // 閉じている場合は開く
        openMenus.push(key);
      }

      // LocalStorageに状態を保存
      localStorage.setItem('sidebarOpenMenus', JSON.stringify(openMenus));
      return { openMenus };
    });
  };
  renderMenu = () => {
    const { commonStore: { settingStore: { setting } } } = this.props;

    const filtered_menu = menus
      .filter(menu => !(
        (setting === null || setting.enable_document_download === ENABLE_DOCUMENT_DOWNLOAD.DISABLE) &&
        menu.key === 'documentsdownload'))
      .map(menu => {
        if (URL_CONFIG.is_connect_to_azure_app_insight === true) {
          return menu;
        }
        // LGWAN用: AI設定の非表示化
        if (menu.key === 'readingsetting') {
          menu.subtree = menu.subtree?.filter(submenu => submenu.key !== 'aisetting');
        }
        return menu;
      });
    return this.renderSidebar(filtered_menu);
  }
  renderSidebar = (tree) => {
    const { t, location, commonStore: { hasPermission } } = this.props;
    const { openMenus } = this.state;

    return tree.map(menu => {
      const { key, path, name, permission, subtree } = menu;
      if (!hasPermission(permission)) {
        return null;
      }
      if (subtree) {
        const isOpen = openMenus.includes(key);
        return (
          <li className={classnames('treeview', { 'menu-open': isOpen })} key={key}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this.handleTreeviewToggle(key);
              }}
            >
              <IconFa type={key} />
              <span>{t(name, name)}</span>
              <IconFa type="toggle" />
            </a>
            <ul className="treeview-menu">
              {this.renderSidebar(subtree)}
            </ul>
          </li>
        );
      }
      return (
        <li className={classnames({ active: location.pathname === path || location.pathname.includes(path + "/") })} key={key}>
          <Link to={path} onClick={() => this.onClickMenu(key, path)}><IconFa type={key} /><span>{t(name, name)}</span></Link>
        </li>
      );
    });
  }
  render() {
    const { t, location, commonStore: {
      hasPermission,
      userStore: { userInfo },
      settingStore: { setting },
    }, } = this.props;
    return (
      <aside className="main-sidebar">
        <section className="sidebar">
          <div className="user-panel">
            <div className="pull-left image">
              <img
                src={userInfo?.avatar ? userInfo?.avatar : URL_CONFIG.default_avatar}
                className="img-circle"
                alt="User"
              />
            </div>
            <div className="pull-left info">
              <p className="user-name">{userInfo?.userName}</p>
            </div>
          </div>
        </section>
        <ul className="sidebar-menu tree">
          {this.renderMenu()}
        </ul>
      </aside>
    );
  }
}

export default withRouter(withTranslation()(MainSidebar));
